
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M634.4 247.1L525.4 71.1C522.2 66.4 517.1 64 512 64s-10.2 2.4-13.4 7.1L389.6 247.1c-3.9 5.8-6.1 12.7-5.5 19.6C389.6 332.4 444.7 384 512 384s122.4-51.6 127.9-117.3c.6-6.9-1.6-13.9-5.5-19.6zM512 352c-41.6 0-77.6-27.1-90.8-64h181.2C589 325.2 553.3 352 512 352zm-90.3-96l90.3-145.8L603 256H421.7zM536 480H336V125.7c22.3-5.8 39.7-23.1 45.6-45.4l148.3-49.6c4.2-1.4 6.5-5.9 5.1-10.1l-5.1-15.2c-1.4-4.2-5.9-6.5-10.1-5.1L381.3 46.7C373.8 19.8 349.3 0 320 0c-35.4 0-64 28.7-64 64 0 8.2 1.7 16 4.5 23.2l-150.5 50.3c-4.2 1.4-6.5 5.9-5.1 10.1l5.1 15.2c1.4 4.2 5.9 6.5 10.1 5.1l160.5-53.7c6.8 5.4 14.7 9.3 23.3 11.6V504c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM288 64c0-17.6 14.4-32 32-32s32 14.4 32 32-14.4 32-32 32-32-14.4-32-32zM141.4 199.1c-3.2-4.8-8.3-7.1-13.4-7.1s-10.2 2.4-13.4 7.1L5.6 375.1c-3.9 5.8-6.1 12.7-5.5 19.6C5.6 460.4 60.7 512 128 512s122.4-51.6 127.9-117.3c.6-6.9-1.6-13.9-5.5-19.6L141.4 199.1zM128 480c-41.6 0-77.6-27.1-90.8-64h181.2C205 453.2 169.3 480 128 480zm-90.3-96l90.3-145.8L219 384H37.7z"}})])
          )
        }
      }
    